import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);
  const refresh = useCallback(() => api.get("/public/site").then((r) => setData(r.data)).catch(() => setData((d) => d || { settings: {}, services: [], pricing: [], gallery: [] })), []);
  useEffect(() => { refresh(); }, [refresh]);
  return <SiteCtx.Provider value={{ ...(data || {}), loading: !data, refresh }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
